import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './assets/css/theme.css'
import './assets/css/App.css';
import 'react-toastify/dist/ReactToastify.css';
import Home from './pages/Home/Home';
import Checkout_post from './pages/Checkout_post/index';
import Login_Message from './pages/Login_Message/index';

import Panel from './pages/panel/Panel';
import Wallet from './pages/panel/Wallet';
import Change_password from "./pages/panel/Change_password";
import My_orders from "./pages/panel/My_orders";
import My_address from "./pages/panel/My_address";
import My_order_view from "./pages/panel/Order_view/My_order_view";

function App() {
  if (!localStorage.getItem('cart')) {
    localStorage.setItem('cart' , JSON.stringify([]))
    localStorage.setItem('price' , 0)
  }

  if (!localStorage.getItem('themes_status')) {
    localStorage.setItem("themes_status","white");
  }

  // <Router basename={"/boncaffe/"}>
  return (
      <div className="App">
       <Router>
      {/*<Router basename={"/boncaffe/"}>*/}



        <Routes>
          <Route path="/" element={<Home />}>
            <Route path=":id" element={<Home />}></Route>
          </Route>

          <Route path="/panel/profile" element={<Panel />} />

          <Route path="/panel/wallet" element={<Wallet />} />
          <Route path="/panel/change-password" element={<Change_password />} />
          <Route path="/panel/my-orders" element={<My_orders />} />
          <Route path="/panel/my-address" element={<My_address />} />
          <Route path="/panel/my-orders/view/:id_post_getuser" element={<My_order_view />} />





          <Route path="/checkout" element={<Checkout_post />} />
          <Route path="/login" element={<Login_Message />} />


        </Routes>
      </Router>
    </div>
  );
}

export default App;
